import type { GetInquiryActionLogsResponse } from 'backend/types'
import { useActionLogs } from '@/hooks/useActionLogs'
import { getInquiryActionLogs } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

export type InquiryActionLog = GetInquiryActionLogsResponse['inquiry_action_logs'][number]
export function useInquiryActionLogs(inquiryId: number) {
  return useActionLogs({
    queryKey: queryKeys.inquiry.actionLogs(inquiryId),
    fetchFn: () => getInquiryActionLogs(inquiryId),
    enabled: inquiryId > 0,
  })
}
